<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="680px">
      <v-form v-model="valid" ref="addForm">
        <small class="pt-0">
          <v-card class="pt-4">
            <v-card-title class="pt-0 pb-0">
              <v-row>
                <v-col>
                  <span class="headline ml-2 caption">{{$t('new_task')}}</span>
                </v-col>
                <v-col md="1">
                  <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 caption">
                    <v-autocomplete
                       :label="$t('task_category')"
                      class="caption"
                      clearable
                      :items="categoryTaskList"
                      item-text="categoryName"
                      item-value="id"
                      v-model="formData.categoryId"
                      @change="fetchAssignee"
                      :rules="[...rules, validator.alfaNumberNotRequired]"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 caption">
                    <v-text-field
                      class="caption"
                      :label="$t('description')"
                      v-model="formData.description"
                      :rules="[validator.alfaNumberNotRequired]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" md="6" class="pt-0 pb-0 caption">
                    <v-label class="f12">{{$t('reporter')}}</v-label>
                    <br />
                    <v-row>
                      <v-col md="2">
                        <v-avatar size="46" class="ma-1">
                          <img
                            :src="avatarUrl"
                            alt="Reporter"
                            onerror="this.onerror=null;this.src='img/logo_initial_gradient.png'"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col md="10">
                        <v-card flat class="pt-0">
                          <v-card-title class="pt-0 ov-hide caption">{{userLoginName}}</v-card-title>
                          <v-card-subtitle class="pt-0 ov-hide caption">{{userLoginJobPosition}}</v-card-subtitle>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col sm="12" md="6" class="pt-0 pb-0">
                    <v-label class="caption">{{$t('assignee')}}</v-label>
                    <br />
                    <v-autocomplete
                      :placeholder="$t('select_assignee')"
                      class="caption"
                      clearable
                      small-chips
                      multiple
                      :items="assigneeList"
                      item-text="full_name"
                      item-value="id"
                      v-model="formData.assignees"
                      :rules="rules"
                      menu-props="closeOnContentClick"
                    >
                      <template #selection="{ item, parent, index }">
                        <!-- <v-avatar size="46" class="ma-1">
                            <v-img
                              :src="item.avatar_url"
                              :alt="item.full_name"
                              onerror="this.onerror=null;this.src='./img/logo_initial_gradient.png'"
                              @error="onImgError"
                            />
                        </v-avatar>-->
                        <div v-if="index == 0" class="caption">
                          <div v-if="parent.value.length > 1" class="caption">
                            <v-chip>{{item.full_name}}</v-chip>
                            and {{parent.value.length-1}} others
                          </div>
                          <div v-else>
                            <v-chip>{{item.full_name}}</v-chip>
                          </div>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <!-- Date Selection -->
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menu"
                      v-model="menu_form_start"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="dateFormatted(formData.startDate)"
                          :label="$t('start_date')"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          color="primary"
                          class="caption"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @change="onStartFormDateChange"
                        v-model="formData.startDate"
                        no-title
                        :locale="$t('locale')"
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      ref="menu"
                      v-model="menu_form_end"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="dateFormatted(formData.endDate)"
                          :label="$t('end_date')"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          color="primary"
                          class="caption"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @change="onEndFormDateChange"
                        v-model="formData.endDate"
                        no-title
                        scrollable
                        :locale="$t('locale')"
                        :min="formData.startDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-file-input
                      :rules="rulesImage"
                      accept="image/png, image/jpg, image/jpeg, application/pdf"
                      :label="$t('file_attachment')"
                      class="caption"
                      v-model="formData.attachment_raw"
                      @change="sendUpload(formData.attachment_raw)"
                    ></v-file-input>
                  </v-col>

                  <v-col>
                    <v-select
                      :items="priorityList"
                      :label="$t('priority')"
                      item-value="id"
                      item-text="name"
                      v-model="formData.priorityId"
                      class="caption"
                      :rules="rules"
                    >
                      <template v-slot:item="{ item }">
                        <v-icon :color="item.color">{{item.icon}}</v-icon>
                        {{item.name}}
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-icon :color="item.color">{{item.icon}}</v-icon>
                        {{item.name}}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="mx-6 pb-6">
              <v-row justify="center">
                <v-btn color text @click="close">Cancel</v-btn>
                <v-btn color="primary" :loading="saveLoading" :disabled="!valid" @click="save">{{$t('save')}}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </small>
      </v-form>
    </v-dialog>

    <v-row>
      <v-col md="3" class="pb-0">
        <v-menu
          ref="menu"
          v-model="menu_start"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateFormat(start_date)"
             :label="$t('start_date')"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              color="primary"
            ></v-text-field>
          </template>
          <v-date-picker v-model="start_date" @change="onStartDateChange" :locale="$t('locale')" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3" class="pb-0">
        <v-menu
          ref="menu"
          v-model="menu_end"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateFormat(end_date)"
              :label="$t('end_date')"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              color="primary"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="end_date"
            @change="onEndDateChange"
            :min="start_date"
            :locale="$t('locale')"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3" class="pa-6">
        <v-btn block color="primary" @click="getTaskList">
          <v-icon>mdi-magnify</v-icon>{{$t('search')}}
        </v-btn>
      </v-col>
      <v-col md="3" class="pa-6">
        <download-excel
          :data="task_report"
          worksheet="Report Task Assignment"
          name="Report Task Assignment.xls"
        >
          <v-btn block outlined color="primary">
            <v-icon>mdi-download</v-icon>{{$t('download_report')}}
          </v-btn>
        </download-excel>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3" class="mt-n4">
        <v-select
          :items="userList"
          item-text="full_name"
          item-value="id"
          v-model="searchusers"
          :placeholder="$t('search_user')"
          @change="getTaskList()"
        ></v-select>
      </v-col>
      <v-col md="3" class="mt-n4">
        <v-select
          :items="groupList"
          item-text="alias"
          item-value="id"
          v-model="searchgroups"
          :placeholder="$t('search_groups')"
          @change="getTaskList()"
        ></v-select>
      </v-col>
      <v-col md="3" class="mt-n4">
        <v-text-field
          v-model="search"
          :label="$t('find_an_assignment')"
          prepend-inner-icon="mdi-magnify"
          single-line
          :rules="[validator.alfaNumberNotRequired]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn right color="primary" dark class="mb-2" @click="addedItem()">{{$t('create_task')}}</v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :search="search"
      :items="task_list"
      :headers="headers"
      class="elevation-1 mt-3"
      :loading="loading"
      :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page')  }"
    >
     <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      <template v-slot:item.createdAt="{ item }">
        <div>{{ dateFormatted(item.createdAt) }}</div>
      </template>
      <template v-slot:item.assignee.user.full_name="{ item }">
        <div>{{ item.assignee.user.full_name }}</div>
      </template>
      <template v-slot:item.statusId="{ item }">
        <div>{{ status(item.statusId) }}</div>
      </template>
      <template v-slot:item.startDate="{ item }">
        <div>
          {{ dateFormatted(item.startDate) }} -
          {{ dateFormatted(item.endDate) }}
        </div>
      </template>
      <template v-slot:item.reporter.user.full_name="{ item }">
        <div>{{ item.reporter.user.full_name }}</div>
      </template>
      <template v-slot:item.details="{ item }">
        <v-icon
          medium
          class="mr-2"
          color="primary"
          @click="openDetailsDialog(item)"
        >mdi-card-account-details-outline</v-icon>
      </template>
      <template v-slot:top>
        <v-dialog v-model="detailsDialog" max-width="500px">
          <v-card v-if="loadingDetails">
            <v-container>
              <v-layout>
                <v-flex md12>
                  <v-card-title class="pt-4">
                    <v-row class="pt-0">
                      <v-col>{{$t('task_details')}} <v-icon :color="colorPriority(taskDetail.priorityId)">{{(iconPriority(taskDetail.priorityId))}}</v-icon></v-col>
                      <v-col md="2" class="pull-right">
                        <v-btn icon @click="detailsDialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-layout >
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('submit_date')}}</span>
                      <span class="caption">{{dateFormatted(taskDetail.createdAt)}}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('work_date')}}</span>
                      <span class="caption">
                        {{ dateFormatted(taskDetail.startDate) }}
                        -
                        {{ dateFormatted(taskDetail.endDate) }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-layout>
                 <v-layout>
                <v-flex md6 v-if="taskDetail.statusId == 5 || taskDetail.statusId == 8">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">Task Duration</span>
                      <span class="caption">{{asMinutes(taskDetail.taskDuration)}}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex md6 v-if="taskDetail.statusId == 5 || taskDetail.statusId == 8 || taskDetail.statusId == 4">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">Start & End</span>
                      <span class="caption">
                        {{ convertDate(taskDetail.workStart) }}
                        <br>
                        {{ convertDate(taskDetail.workEnd) }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('reporter')}}</span>
                      <span class="caption">
                        <v-avatar color="primary" size="26">
                          <img
                            :src="repoterDetail.avatar_url != null ? repoterDetail.avatar_url : 'img/neutral.svg'"
                            alt="Avatar"
                          />
                        </v-avatar>
                        &nbsp;{{ repoterDetail.full_name }}
                      </span>
                      <span class="caption" style="margin-left:5px;">
                        <v-icon small color="primary">mdi-account-group</v-icon>
                        &nbsp;{{ repoterGroup }}
                      </span>
                      <div
                        v-if="taskDetail.reporter ? taskDetail.reporter.attachment != '-' ? false : true: false"
                      >
                        <span class="caption" style="margin-left:5px;">{{$t('no_attachment')}}</span>
                      </div>
                      <div v-else>
                        <a
                          :href="taskDetail.reporter? taskDetail.reporter.attachment: '-'"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="text-decoration:none;"
                        >
                          <span class="caption" style="margin-left:5px;">
                            <v-icon small color="primary">mdi-attachment</v-icon>&nbsp;{{$t('attachment')}}
                          </span>
                        </a>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('assignee')}}</span>
                      <span class="caption">
                        <v-avatar size="26">
                          <img
                            :src="
                              assigneeDetail.avatar_url != null
                                ? assigneeDetail.avatar_url
                                : 'img/neutral.svg'
                            "
                            alt="Avatar"
                          />
                        </v-avatar>
                        &nbsp;{{ assigneeDetail.full_name }}
                      </span>
                      <span class="caption" style="margin-left:5px;">
                        <v-icon small color="primary">mdi-account-group</v-icon>
                        &nbsp;{{ assigneeGroup }}
                      </span>
                      <div
                        v-if="taskDetail.assignee ? taskDetail.assignee.attahcment != '-' ? false : true : false"
                      >
                        <span class="caption" style="margin-left:5px;">{{$t('no_attachment')}}</span>
                      </div>
                      <div v-else>
                        <a
                          :href="taskDetail.assignee? taskDetail.assignee.attahcment: '-'"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="text-decoration:none;"
                        >
                          <span class="caption" style="margin-left:5px;">
                            <v-icon small color="primary">mdi-attachment</v-icon>&nbsp;{{$t('attachment')}}
                          </span>
                        </a>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('status')}}</span>
                      <span class="caption">
                        <v-chip
                          label
                          x-small
                          :color="checkStatusColor(taskDetail.statusId)"
                        >{{ status(taskDetail.statusId) }}</v-chip>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('task_details')}}</span>
                      <span class="caption">
                        {{ taskDetail.categoryCode }} -
                        {{ taskDetail.categoryName }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('description')}}</span>
                      <span class="caption">{{ taskDetail.description }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex md6>
                  <v-list-item>
                    <v-list-item-content>
                      <span class="caption font-weight-bold">{{$t('history_status')}}</span>
                      <div v-for="(item, i) in commentApprover" :key="i">
                        <v-list-item-title class="subtitle-2">
                          <span class="caption">{{ dateFormatted(item.date) }}</span>
                        </v-list-item-title>
                        <span class="caption">{{ item.user.full_name }}</span>
                        <br />
                        <span class="caption">{{ status(item.statusId) }}</span>
                        <div v-if="item.statusId == 8 " class="mt-2">
                          <div class="font-weight-bold f-12">Rating:</div>
                          <div class="caption font-italic">"{{item.comment}}"</div>
                          <v-icon :class="starBox(1, item.rating)">mdi-star</v-icon>
                          <v-icon :class="starBox(2, item.rating)">mdi-star</v-icon>
                          <v-icon :class="starBox(3, item.rating)">mdi-star</v-icon>
                          <v-icon :class="starBox(4, item.rating)">mdi-star</v-icon>
                          <v-icon :class="starBox(5, item.rating)">mdi-star</v-icon>
                        </div>
                         <div v-if="item.statusId == 3 " class="mt-2">
                          <div class="font-weight-bold f-12">Reason:</div>
                          <div class="caption font-italic">"{{item.reason}}"</div>
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ENV from './../../../store/modules/environtment'

export default {
  name: "task",
  data() {
    return {
      reset: false,
      menu_form_start: false,
      menu_form_end: false,
      saveLoading: false,
      formData: {
        categoryId: null,
        userId: null,
        assignees: [],
        description: null,
        priorityId: null,
        startDate: "",
        endDate: "",
        attachment: null,
        attachment_raw: null,
        attachmentPrefix: '-',
        attachmentAlias: '-',
        attachmentExt: null,
        statusId: 1,
      },
      priorityList: [
        { id: 3, name: this.$i18n.t('low'), icon: 'mdi-arrow-down', color: 'success' },
        { id: 2, name: this.$i18n.t('medium'), icon: 'mdi-arrow-up', color: 'warning' },
        { id: 1, name: this.$i18n.t('high'), icon: 'mdi-arrow-up', color: 'error' },
      ],
      rulesImage: [
        value => (value == null ? true : value.length == 0 ? true : value.size < 1000000 || this.$i18n.t('image_1mb')),
      ],
      valid: true,
      headers: [
        { text: this.$i18n.t('submit_date'), value: "createdAt" },
        { text: this.$i18n.t('task_category'), value: "categoryName" },
        { text: this.$i18n.t('reporter'), value: "reporter.user.full_name" },
        { text: this.$i18n.t('assignee'), value: "assignee.user.full_name" },
        { text: this.$i18n.t('work_date'), value: "startDate" },
        { text: this.$i18n.t('status'), value: "statusId" },
        { text: this.$i18n.t('action'), value: "details" },
      ],
      assigneeList: [],
      categoryTaskList: [],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      user_id: this.$store.state.user.id,
      search: "",
      groupList: [],
      task_list: [],
      task_report: [],
      searchgroups: null,
      searchusers: null,
      userList: [],
      taskDetail: [],
      loadingDetails: true,
      detailsDialog: false,
      repoterDetail: [],
      assigneeDetail: [],
      assigneeGroup: [],
      repoterGroup: [],
      date: new Date().toISOString().substr(0, 10),
      menu_start: false,
      menu_end: false,
      start_date: "",
      end_date: "",
      commentApprover: [],
      loading: true,
      dialog: false,
      rules: [v => !!v || this.$i18n.t('field_required')],
    };
  },
  computed: {
    avatarUrl() {
      return this.$store.state.user.avatar;
    },
    userLoginName() {
      return this.$store.state.user.name;
    },
    userLoginJobPosition() {
      return this.$store.state.user.detail.jobPosition;
    },
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    async sendUpload(image) {
      if (image) {
        if (image.name) {
          this.saveLoading = true
          const data = await this.uploadImage(image)
          this.saveLoading = false
          this.formData.attachment = data.fileName
          this.formData.attachmentPrefix = data.path
          const split = this.formData.attachment_raw.type.split('/')[1]
          this.formData.attachmentExt = split
        }
      }
    },
    async uploadImage(image) {
      const prefix = ENV.firebase.prefixTaskAssigment
      const companyId = this.$store.state.company
      const url = `${this.baseUrl}/download/file_upload_general`
      const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'File Upload', actionId: 1 } }
      try {
        const formData = new FormData();
        formData.append('file', image)
        formData.append('path', `${prefix}${companyId}/${this.user_id}/task_assignment`)

        const result = await axios.post(url, formData, headers)
        if (result) {
          if (result.data.code == 200) return result.data.data
        }
        this.showMessage('warning', 'Upload tidak berhasil')
        return { url: 'img/default-image.png' }
      } catch (e) {
        this.showMessage('error', 'Upload tidak berhasil')
        // eslint-disable-next-line no-console
        console.error(e.message)
        return { url: 'img/default-image.png' }
      }
    },
    close() {
      this.reset = true
      this.dialog = false;
    },
    addedItem() {
      this.formData = {
        categoryId: null,
        userId: null,
        assignees: [],
        description: null,
        priorityId: null,
        startDate: "",
        endDate: "",
        attachment: null,
        attachment_raw: null,
        attachmentPrefix: '-',
        attachmentAlias: '-',
        attachmentExt: null,
        statusId: 1,
      }
      this.dialog = true;
    },
    onStartDateChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start = false;
    },
    onEndDateChange() {
      this.menu_end = false;
    },
    onStartFormDateChange() {
      const diff = moment(this.formData.endDate).diff(this.formData.startDate, 'days')
      if (diff < 0) this.formData.endDate = this.formData.startDate
      this.menu_form_start = false;
    },
    onEndFormDateChange() {
      this.menu_form_end = false;
    },

    dateFormat(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
    },
    checkStatusColor(item) {
      switch (item) {
        case 1: return 'success'
        case 2: return 'default'
        case 3: return 'error'
        case 4: return 'primary'
        case 5: return 'primary'
        case 6: return 'warning'
        case 7: return 'error'
        case 8: return 'success'
        default: return 'default'
      }
    },
    status(item) {
      switch (item) {
        case 1: return this.$i18n.t('waiting')
        case 2: return this.$i18n.t('to-do')
        case 3: return this.$i18n.t('decline')
        case 4: return this.$i18n.t('in-progress')
        case 5: return this.$i18n.t('need-review')
        case 6: return this.$i18n.t('need-revision')
        case 7: return this.$i18n.t('canceled')
        case 8: return this.$i18n.t('completed')
      }
    },
    openDetailsDialog(item) {
      this.loadingDetails = true;
      this.detailsItem = Object.assign({}, item);
      this.taskDetail = item;
      this.repoterDetail = item.reporter.user;
      this.assigneeDetail = item.assignee.user;
      this.repoterGroup = item.reporter.user.group.alias;
      this.assigneeGroup = item.assignee.user.group.alias;
      this.detailsDialog = true;
      this.commentApprover = item.taskHistories;
    },
    dateFormatted(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("DD/MM/YYYY");
    },
    milisToHour(milis) {
        return moment(milis, "x").format("HH:mm:ss");
    },
    convertDate(milis) {
      return moment(milis, "x").format("MMMM Do YYYY, HH:mm");
    },
    asMinutes(milis){
      if(milis >= 3600000) {
    return moment.duration(milis).format("HH:mm:ss")
    }else{
       return "00:" + moment.duration(milis).format("HH:mm:ss")
    }


    },
    async getTaskList() {
      this.loading = true;
      let date_start = moment(this.start_date).format("DD-MM-YYYY");
      let date_end = moment(this.end_date).format("DD-MM-YYYY");
      let params = {
        startDate: date_start,
        endDate: date_end,
        groupId: '',
        userId: '',
      }
      if (this.searchgroups) params.groupId = this.searchgroups
      if (this.searchusers) params.userId = this.searchusers
      const result = await this.$store.dispatch('getTaskAssignmentReport', params)
      this.loading = false;
      this.task_list = result;
      this.task_report = [];
      result.forEach((row) => {
        let reportAssignment = {};
        reportAssignment[this.$i18n.t('submit_date')] = this.dateFormatted(row.createdAt);
        reportAssignment[this.$i18n.t('task_category')] = row.categoryName;
        reportAssignment[this.$i18n.t('reporter')] = row.reporter.user.full_name;
        reportAssignment[this.$i18n.t('assignee')] = row.assignee.user.full_name;
        reportAssignment[this.$i18n.t('start_date')] = this.dateFormatted(row.startDate);
        reportAssignment[this.$i18n.t('end_date')] = this.dateFormatted(row.endDate);
        reportAssignment[this.$i18n.t('status')] = this.status(row.statusId);

        this.task_report.push(reportAssignment);
      })
    },
    async fetchGroupDetails() {
      const result = await this.$store.dispatch('getTaskAssignmentByRole', { userId:this.user_id })
      this.groupList = result;
      if (this.$store.state.role != 3) {
        this.groupList.unshift({ alias: this.$i18n.t('all_group'), id: null });
      }
    },
    checkRoleToGetUserAssignee(users) {
      const result = []
      if (this.$store.state.role == 3) {
        const groupId = this.$store.state.user.detail.groupId
        users.map(item => {
          if (item.groupId == groupId) { result.push(item) }
        })
        return result
      } else {
        return users
      }
    },
    async fetchAssignee() {
      const result = await this.$store.dispatch('getTaskAssignmentAssignee', { userId: this.user_id, taskId: this.formData.categoryId })
      this.assigneeList = this.checkRoleToGetUserAssignee(result)
    },
    async fetchGroupCategory() {
      this.categoryTaskList = await this.$store.dispatch('getTaskAssignment', { userId: this.user_id })
    },
    async fetchUserDetails() {
      const result = await this.$store.dispatch('getTaskAssignmentConfigCMS')
      this.userList = result.assingeeList;
      this.userList.unshift({ full_name: this.$i18n.t('all_user'), id: null });
    },
    async save() {
      this.saveLoading = true
      const data = this.formData
      const body = {
        categoryId: data.categoryId,
        userId: this.user_id,
        assignees: data.assignees,
        description: data.description,
        priorityId: data.priorityId,
        startDate: moment(data.startDate, 'YYYY-MM-DD').format("DD-MM-YYYY"),
        endDate: moment(data.endDate, 'YYYY-MM-DD').format("DD-MM-YYYY"),
        attachment: data.attachment,
        attachmentPrefix: data.attachmentPrefix,
        attachmentAlias: "-",
        attachmentExt: data.attachmentExt,
        statusId: 1
      }
      const result = await this.$store.dispatch('saveTaskAssignmentMultiAssignee', body)
      this.saveLoading = false
      if (result) {
        this.showMessage('success', 'Berhasil tersimpan')
        this.getTaskList()
        this.reset = true
        this.dialog = false
      }
    },
  starBox(stars, rating){
    if(rating >= stars ){
      return 'yellow-stars'
    }else{
      return 'gray-stars'
    }
  },
   iconPriority(item) {
      switch (item) {
        case 1: return 'mdi-arrow-up'
        case 2: return 'mdi-arrow-up'
        case 3: return 'mdi-arrow-down'
      }
    },
    colorPriority(item) {
      switch (item) {
        case 1: return 'error'
        case 2: return 'warning'
        case 3: return 'success'
      }
    }
  },
  created() {
    this.start_date = moment().subtract(1, "days").format("YYYY-MM-DD")
    this.end_date = moment().format("YYYY-MM-DD")

    this.fetchGroupCategory()
    this.getTaskList()
    this.fetchGroupDetails()
    this.fetchUserDetails()
  },
  watch: {
    dialog(show) {
      if (this.$refs.addForm && this.reset && show) {
        this.$refs.addForm.reset();
        this.reset = false
      }
      setTimeout(() => {
        this.formData.startDate = moment().subtract(1, "days").format("YYYY-MM-DD")
        this.formData.endDate = moment().format("YYYY-MM-DD")
      }, 100);
    }
  }
};
</script>
<style scoped>
.yellow-stars{
  color: gold;
  font-size: 14px;
}
.gray-stars{
  color: gray;
  font-size: 14px;
}
</style>
<style>
.v-text-field input {
  font-size: 1rem !important;
}
.ov-hide {
  overflow: hidden;
  white-space: nowrap;
}
.f12 {
  font-size: 1rem !important;
}
</style>